import JSZip from 'jszip'

/**
 * Generates a zip file in the form of a Blob.
 *
 * @param name Name of zip file
 * @param {Record<string, string | number[] | Uint8Array | ArrayBuffer | Blob>} files Object where
 *   keys are the path to the files to create and the values are the file contents
 * @returns {Promise<Blob>} A Blob representing the zip file
 */
export default function zip(
  name: string,
  files: Record<string, string | number[] | Uint8Array | ArrayBuffer | Blob>
): Promise<Blob> {
  const zip = new JSZip()

  const folder = zip.folder(name) as JSZip
  Object.entries(files).forEach(([path, data]) => {
    folder.file(path, data, { createFolders: true })
  })

  return zip.generateAsync({ type: 'blob' })
}
